import clsx from "clsx";
import Badge from "./Badge";

const BadgeBrainRegion = ({ region, className, ...props }) => {
  const regions = {
    prefrontal: "yellow",
    frontal: "red",
    central: "violet",
    parietal: "green",
    temporal: "cyan",
    occipital: "blue",
  };

  return (
    region && (
      <Badge
        variant={clsx(regions[region])}
        className={clsx("capitalize", className)}
        {...props}
      >
        {region}
      </Badge>
    )
  );
};

export default BadgeBrainRegion;
